import styles from "./ToggleSwitch.module.css";

type ToggleProps = {
  checked: boolean;
  onChange?: (value: boolean) => void;
  scale?: number;
};

export function ToggleSwitch({ checked, onChange, scale = 1 }: ToggleProps) {
  return (
    <label className={styles.toggle} style={{ transform: `scale(${scale})` }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
      />
      <span className={styles.slider} />
    </label>
  );
}
